<ng-content></ng-content>
<a class="type-toggle" (click)="toggleShow()">
  <i class="show-option feather icon-eye" [hidden]="!showPassword" name="eye-off-outline"></i>
  <i class="hide-option feather icon-eye-off" [hidden]="showPassword" name="eye-outline"></i>
</a>
